"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkSchema = exports.LinkTypeEnum = void 0;
const zod_1 = require("zod");
var LinkTypeEnum;
(function (LinkTypeEnum) {
    LinkTypeEnum["WEB"] = "WEB";
    LinkTypeEnum["BLOG"] = "BLOG";
    LinkTypeEnum["TELEGRAM"] = "TELEGRAM";
    LinkTypeEnum["INSTAGRAM"] = "INSTAGRAM";
    LinkTypeEnum["X"] = "X";
})(LinkTypeEnum || (exports.LinkTypeEnum = LinkTypeEnum = {}));
exports.LinkSchema = zod_1.z.object({
    id: zod_1.z.nativeEnum(LinkTypeEnum),
    uri: zod_1.z.string(),
});
